import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { setRedirectUrl } from '../lib/utils';

export const useAuthRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      // Store the current location as the redirect URL
      const currentPath = location.pathname + location.search;
      setRedirectUrl(currentPath);
      navigate('/login');
      setIsAuthenticated(false);
    } else {
      setIsAuthenticated(true);
    }
    setIsChecking(false);
  }, [navigate, location]);

  return { isAuthenticated, isChecking };
}; 